import { Injectable, Injector } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { PnpClientService } from 'src/pnpframework/public-api';
import { isNullOrUndefined } from 'src/app/services/utils';
import { ActivatedRouteSnapshot } from '../../../node_modules/@angular/router';
import { environment } from '../../environments/environment';
import { API_PARAMS_CONST, COMMON_CONSTANTS, MANAGE_LINE_CONST } from '../common/core/common.constants';
import { APIGEE_TOKEN_URL } from '../common/core/urls.constants';
import { CommonConfirmationModalComponent } from '../shared/components/common-confirmation-modal/common-confirmation-modal.component';

import { ContentService } from './content.service';

import { DecodeParamsService } from './decode-params.service';
import { EnvironmentDetailsService } from './environment-details.service';

import { HttpCacheService } from './http-cache.service';
import { LoaderService } from './loader.service';
import { WindowServiceService } from './window-service.service';

@Injectable({
    providedIn: 'root',
})
export class SetupRouteService {

    isResolved: boolean;
    isLoaded: boolean;
    euiCode: any;
    BanNumber: string;
    OrgID: string;
    BillPayFlag: string;
    ReturnURI: string;
    authType: string;
    userId: string;
    firstName: string;
    lastName: string;
    logonId: string;
    roleId: any;
    msisdn: any;
    token: string;
    flow: string;
    clientAppName: string;
    authoringContentData: any;
    ssoMessage = { error: '', show: true, errorType: 'generic' };
    private checkForEUIedirect = new BehaviorSubject(false);
    isEuiRedirect = this.checkForEUIedirect.asObservable();
    transactionID: any;
    isRedirect = false;
    private tab = "";
    private _cacheSvc: HttpCacheService;
    private decodeParamsSvc: DecodeParamsService;
    private _envSvc: EnvironmentDetailsService;
    public contentService: ContentService;
    private _loaderSvc: LoaderService;
    private pnpClientService: PnpClientService;
    private _modalSvc: NgbModal;
    private _windowService: WindowServiceService;

    constructor(private injector: Injector) {
        this._cacheSvc = this.injector.get<HttpCacheService>(HttpCacheService);
        this.decodeParamsSvc = this.injector.get<DecodeParamsService>(DecodeParamsService);
        this._envSvc = this.injector.get<EnvironmentDetailsService>(EnvironmentDetailsService);
        this.contentService = this.injector.get<ContentService>(ContentService);
        this._loaderSvc = this.injector.get<LoaderService>(LoaderService);
        this.pnpClientService = this.injector.get<PnpClientService>(PnpClientService);
        this._modalSvc = this.injector.get<NgbModal>(NgbModal);
        this._windowService = this.injector.get<WindowServiceService>(WindowServiceService);
        
        this.flow = COMMON_CONSTANTS.ENROLL_FLOW;
        this.token = '';

      
        if (!(sessionStorage.getItem(COMMON_CONSTANTS.TRANSACTIONID))) {
            const now = new Date();
            this.transactionID = now.valueOf();
            this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.TRANSACTIONID, this.transactionID);
        }
    }

    tokenResolved() : any {
      // This call Gets tokens and content data
       // return this._apigeeSvc.getTokens().then((token) => {
          return this.contentService.GetContentData(this._envSvc.CURR_CONTENT_URLS.CONTENT_ACCOUNT_MANAGEMENT).then(data => {
              this.authoringContentData = data.par.account_management_authoring;
              this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.CONTENT, JSON.stringify(this.authoringContentData));
              this._loaderSvc.stop();
              this.isResolved = true;
          });
  }

    saveParamsInSession(route: ActivatedRouteSnapshot) {
        if (route.queryParamMap) {
            const queryParam = this.decodeParamsSvc.decodeBase64(route.queryParamMap.get(COMMON_CONSTANTS.UID_KEY) ?
                route.queryParamMap.get(COMMON_CONSTANTS.UID_KEY) : '');

            this.BanNumber = queryParam[COMMON_CONSTANTS.BAN_NUMBER_KEY] ?
                queryParam[COMMON_CONSTANTS.BAN_NUMBER_KEY] :
                this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY);

            this.OrgID = queryParam[COMMON_CONSTANTS.ORG_ID_KEY] ?
                queryParam[COMMON_CONSTANTS.ORG_ID_KEY] :
                this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ORG_ID_KEY);

            this.ReturnURI = queryParam[COMMON_CONSTANTS.RETURN_URL_SSP] ?
                queryParam[COMMON_CONSTANTS.RETURN_URL_SSP] :
                this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.RETURN_URL_SSP);

            this.userId = queryParam[COMMON_CONSTANTS.USER_ID] ?
                queryParam[COMMON_CONSTANTS.USER_ID] :
                this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.USER_ID);

            this.firstName = queryParam[COMMON_CONSTANTS.FIRST_NAME] ?
                queryParam[COMMON_CONSTANTS.FIRST_NAME] :
                this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.FIRST_NAME);

            this.lastName = queryParam[COMMON_CONSTANTS.LAST_NAME] ?
                queryParam[COMMON_CONSTANTS.LAST_NAME] :
                this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.LAST_NAME);

            this.logonId = queryParam[COMMON_CONSTANTS.LOGON_ROUTER_ID] ?
                queryParam[COMMON_CONSTANTS.LOGON_ROUTER_ID] :
                this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.LOGON_ROUTER_ID);

            this.roleId = queryParam[COMMON_CONSTANTS.ROLE_ID] ?
                queryParam[COMMON_CONSTANTS.ROLE_ID] :
                this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ROLE_ID);

            this.msisdn = queryParam[COMMON_CONSTANTS.MSISDN] ?
                queryParam[COMMON_CONSTANTS.MSISDN] :
                this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.MSISDN);

            if (queryParam[COMMON_CONSTANTS.AUTH_TYPE]) {
                this.authType = queryParam[COMMON_CONSTANTS.AUTH_TYPE];
            } else if (!isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE))) {
                this.authType = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE);
            } else {
                this.authType = COMMON_CONSTANTS.IAM_KEY;
            }

            this.tab = queryParam[COMMON_CONSTANTS.TAB] || this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.TAB);
        }

        this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.BAN_NUMBER_KEY, this.BanNumber);
        this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.ORG_ID_KEY, this.OrgID);
        this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.RETURN_URL_SSP, this.ReturnURI);
        this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.USER_ID, this.userId);
        this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.FIRST_NAME, this.firstName);
        this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.LAST_NAME, this.lastName);
        this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.LOGON_ROUTER_ID, this.logonId);
        this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.ROLE_ID, this.roleId);
        this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.MSISDN, this.msisdn);
        this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.AUTH_TYPE,
            isNullOrUndefined(this.authType) ? this.authType : this.authType.toLowerCase());
        this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.TAB, this.tab);
    }

    euiLoginRedirect(queryParam?) {
        let url = environment.iamRedirectUrl;
        let client = API_PARAMS_CONST.EUI_CLIENT_ID;
         if(this.pnpClientService.isRunningInGlobalNav()){
            url= environment.GN_REDIRECT_URL;
            client= API_PARAMS_CONST.EUI_CLIENT_ID_BILLING;
         }
        const euiURL = environment.EUI_ENDPOINT +
        APIGEE_TOKEN_URL.EUI_GET_CODE_REDIRECT_URL.path?.replace(COMMON_CONSTANTS.HOST_PLACEHOLDER, url)
        ?.replace(COMMON_CONSTANTS.CLIENT_PLACEHOLDER, client) + (queryParam || '');
        this._windowService.redirectTo(euiURL);
        this.checkForEUIedirect.next(true);
        this.isRedirect = true;
    }

    showConfirmationModal(route?: string){
        const authoringContentData =  JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.CONTENT));
        const ngbModalOptions: NgbModalOptions = {
          backdrop: 'static',
          keyboard: false,
          centered: false,
          container: '#am-container-custom',
        }; 
        this._modalSvc.dismissAll();
        const simSwapRedirectReference = this._modalSvc.open(CommonConfirmationModalComponent,ngbModalOptions);
        if(route === MANAGE_LINE_CONST.MANAGE_SIM_PROTECTION_CTA_TXT) {
            simSwapRedirectReference.componentInstance.header= authoringContentData?.manageLine?.authModalHeader;
            simSwapRedirectReference.componentInstance.message = authoringContentData?.manageLine?.authModalSimProtection; 
        }else if(route === MANAGE_LINE_CONST.TURN_ON_SIM_PROTECTION_CTA_TXT){
            simSwapRedirectReference.componentInstance.header= authoringContentData?.manageLine?.authModalHeader;
            simSwapRedirectReference.componentInstance.message = authoringContentData?.manageLine?.authModalSimProtectionOn; 
        }else if(route === MANAGE_LINE_CONST.TURN_OFF_SIM_PROTECTION_CTA_TXT){
            simSwapRedirectReference.componentInstance.header= authoringContentData?.manageLine?.authModalHeader;
            simSwapRedirectReference.componentInstance.message = authoringContentData?.manageLine?.authModalSimProtectionOff; 
        }else if(route === MANAGE_LINE_CONST.PORT_OUT_ON_PROTECTION_CTA_TXT) {
            simSwapRedirectReference.componentInstance.header= authoringContentData?.manageLine?.authModalHeader;
            simSwapRedirectReference.componentInstance.message = authoringContentData?.manageLine?.authModalPortOutProtectionOn; 
        }else if(route === MANAGE_LINE_CONST.PORT_OUT_OFF_PROTECTION_CTA_TXT) {
            simSwapRedirectReference.componentInstance.header= authoringContentData?.manageLine?.authModalHeader;
            simSwapRedirectReference.componentInstance.message = authoringContentData?.manageLine?.authModalPortOutProtectionOff; 
        }else if(route === MANAGE_LINE_CONST.MANAGE_PORT_OUT_PROTECTION_CTA_TXT) {
            simSwapRedirectReference.componentInstance.header= authoringContentData?.manageLine?.authModalHeader;
            simSwapRedirectReference.componentInstance.message = authoringContentData?.manageLine?.authModalManagePortOutProtection; 
        }else if(route === MANAGE_LINE_CONST.SIM_DEVICE_LOCK_CTA_TXT){
            simSwapRedirectReference.componentInstance.header= authoringContentData?.manageLine?.authModalHeader;
            simSwapRedirectReference.componentInstance.message = authoringContentData?.manageLine?.authModalLockSimToDevice; 
        }else if(route === MANAGE_LINE_CONST.SIM_DEVICE_UNLOCK_CTA_TXT){
            simSwapRedirectReference.componentInstance.header= authoringContentData?.manageLine?.authModalHeader;
            simSwapRedirectReference.componentInstance.message = authoringContentData?.manageLine?.authModalUnlockSimToDevice; 
        }else if (route === MANAGE_LINE_CONST.MANAGE_SIM_DEVICE_UNLOCK_CTA_TXT){
            simSwapRedirectReference.componentInstance.header= authoringContentData?.manageLine?.authModalHeader;
            simSwapRedirectReference.componentInstance.message = authoringContentData?.manageLine?.authModalManageSimToDevice; 
        }
        else if(route === 't-pop'){                          
            simSwapRedirectReference.componentInstance.header= authoringContentData?.tpop?.authModalHeader;
            simSwapRedirectReference.componentInstance.message = authoringContentData?.tpop?.authModelTpop; 
        }
        
        else if(route === 't-pop-bulk'){
            simSwapRedirectReference.componentInstance.header= authoringContentData?.manageLine?.authModalHeader;
            simSwapRedirectReference.componentInstance.message = authoringContentData?.manageLine?.authModalTpop;
        }
        else if(route === 't-pop-view'){                          
            simSwapRedirectReference.componentInstance.header= authoringContentData?.tpop?.authModalHeader;
            simSwapRedirectReference.componentInstance.message = authoringContentData?.tpop?.viewpin; 
        }
        else {
            simSwapRedirectReference.componentInstance.message = authoringContentData?.changeSim?.secureIdRedirectionMessage;
        }
        simSwapRedirectReference.componentInstance.isYesButtonClicked.subscribe((data)=>{
          this.loginRedirect(data, route);
        });
        
      }

      loginRedirect(data, route){
        if(data){
            let ban = this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN);
            this._cacheSvc.putInSessionStoarage('fcc-redirect-ban', ban);
            if (route=='t-pop-view'){
                this._cacheSvc.putInSessionStoarage('view-pin-auth', true);
            }
            this.euiLoginRedirect(COMMON_CONSTANTS.ACR_VALUES_PARAM);
          } else{
            this._modalSvc.dismissAll();
          }
      }
   
}
